module.exports = __webpack_public_path__ + "static/index/img/baikal-707.1c2401c7.jpg";